"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.lowerFirst = lowerFirst;
function lowerFirst(str) {
    if (str === undefined || str === null) {
        return str;
    }
    return `${str.charAt(0).toLowerCase()}${str.slice(1)}`;
}
//# sourceMappingURL=lowerFirst.js.map